import { Link, useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { Splash } from '../../components/Guard';
import { useAuth } from '../../lib/auth';
import { isNative } from '../../lib/native';
import { Onboarding, onboardingSeen } from '../onboarding/Onboarding';
import { Landing } from '../landing/Landing';
import { SignInPanel } from './SignInPanel';
import { useT } from '../../i18n';

export function Welcome() {
  const { user, ready } = useAuth();
  const nav = useNavigate();
  const [seen, setSeen] = useState(onboardingSeen);
  useEffect(() => {
    if (user) void nav({ to: '/trees' });
    // In the apps, signed-out people go to sign-in once they've seen the intro slides.
    else if (isNative && ready && seen) void nav({ to: '/sign-in', search: { redirect: undefined }, replace: true });
  }, [user, ready, seen, nav]);
  // The apps get intro slides instead of the web landing page.
  if (isNative) return ready && !user && !seen ? <Onboarding onDone={() => setSeen(true)} /> : <Splash />;
  // Render the landing page straight away (best for first paint and sharing); signed-in visitors are redirected once auth resolves.
  return <Landing />;
}

export function SignInPage({ redirect }: { redirect?: string }) {
  const t = useT();
  const { user, ready } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    if (user) {
      if (redirect && redirect.startsWith('/')) window.location.assign(redirect);
      else void nav({ to: '/trees' });
    }
  }, [user, redirect, nav]);
  if (!ready || user) return <Splash />;
  return (
    <div className="center">
      <div className="stack" style={{ maxWidth: 380, width: '100%' }}>
        <span className="wordmark">Lineage</span>
        <h1 style={{ fontSize: 34 }}>{t.auth.signIn}</h1>
        <SignInPanel />
        {/* In the apps "/" is the intro, which sends people straight back here. */}
        {!isNative && <Link to="/" className="muted" style={{ fontSize: 14 }}>{t.common.back}</Link>}
      </div>
    </div>
  );
}
